import Cookies from "js-cookie";
import { API_BASE_URL, HEADER_SUBSCRIPTION_KEY } from "./global";

// Function to get the JWT token from the cookie
export const getToken = () => Cookies.get("token");

export async function saveLocation(location) {
  const token = getToken();
  const url = API_BASE_URL + "/save-location";
  if (!token) {
    throw new Error("No token found");
  }
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": HEADER_SUBSCRIPTION_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(location),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function saveNewSite(site) {
  const token = getToken();
  const url = API_BASE_URL + "/save-site";
  if (!token) {
    throw new Error("No token found");
  }
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": HEADER_SUBSCRIPTION_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(site),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function deleteLocation(locationId) {
  const token = getToken();
  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await fetch(
      `${API_BASE_URL}/delete-location?locationId=${locationId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": HEADER_SUBSCRIPTION_KEY,
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function deleteSite(siteId) {
  const token = getToken();
  if (!token) {
    throw new Error("No token found");
  }
  try {
    const response = await fetch(
      `${API_BASE_URL}/delete-site?siteId=${siteId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": HEADER_SUBSCRIPTION_KEY,
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return null;
  }
}

export async function deleteScheduleTime(schedule) {
  const token = getToken();
  if (!token) {
    throw new Error("No token found");
  }
  try {
    const response = await fetch(
      `${API_BASE_URL}/delete-schedule-time?id=${schedule.id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": HEADER_SUBSCRIPTION_KEY,
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if(response.ok) {
      const data = await response.json();
      return data.responseCode;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}

export async function saveUpdateSchedule(schedule) {
  const token = getToken();
  const url = API_BASE_URL + "/save-schedule-time";
  if (!token) {
    throw new Error("No token found");
  }
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": HEADER_SUBSCRIPTION_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(schedule),
    });
    if(response.ok) {
      const data = await response.json();
      return (data.responseCode === 200) ? (data.load ?? null) : null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}
